import { onMounted, ref, watch } from 'vue';
import { useI18n } from '@/composables';

type FlowMultiValueConditionEntry = {
  predicate: string;
  values: string[];
};

type FlowConditions = Record<string, FlowMultiValueConditionEntry>;

export const useFlowDayOfWeekCondition = (conditions: FlowConditions) => {
  const { t } = useI18n();

  const predicate = ref('EQUALS');
  const selected = ref<Array<string | false>>(new Array(7).fill(false));

  const days = [
    t('Sunday'),
    t('Monday'),
    t('Tuesday'),
    t('Wednesday'),
    t('Thursday'),
    t('Friday'),
    t('Saturday'),
  ];

  watch(
    () => conditions,
    () => {
      if (!conditions.dayOfWeek) {
        conditions.dayOfWeek = {
          predicate: 'EQUALS',
          values: [],
        };
      }
    },
    { immediate: true },
  );

  watch(
    selected,
    (value) => {
      conditions.dayOfWeek.values = value.filter((item) => item) as string[];
    },
    { deep: true },
  );

  watch(predicate, (value) => {
    conditions.dayOfWeek.predicate = value;
  });

  onMounted(() => {
    if (conditions.dayOfWeek?.values?.length) {
      selected.value = days.map((day) =>
        conditions.dayOfWeek.values.indexOf(day) !== -1 ? day : false,
      );
      predicate.value = conditions.dayOfWeek.predicate || predicate.value;
    }
  });

  return {
    t,
    days,
    predicate,
    selected,
  };
};
